import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight, GraduationCap, Users, Sparkles } from "lucide-react";
import Section from "@/components/Section";
import Reveal from "@/components/Reveal";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/i18n/useLanguage";

const chips = [
  { key: "leaders", icon: Users },
  { key: "lyftet", icon: Sparkles },
  { key: "masterclass", icon: GraduationCap },
] as const;

const AiSkillingTeaser = () => {
  const { t } = useTranslation();
  const { localize } = useLanguage();

  return (
    <Section
      title={
        <>
          {t("homeSkilling.titlePre")}{" "}
          <span className="text-gradient-brand">{t("homeSkilling.titleAccent")}</span>
        </>
      }
      containerSize="narrow"
    >
      <Reveal className="flex flex-wrap gap-3 justify-center mb-8 md:mb-10" delay={120}>
        {chips.map(({ key, icon: Icon }) => (
          <span
            key={key}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-border/60 bg-card/60 backdrop-blur-sm text-sm font-medium"
          >
            <Icon className="w-4 h-4 text-primary" />
            {t(`homeSkilling.chips.${key}`)}
          </span>
        ))}
      </Reveal>

      <Reveal className="text-center" delay={200}>
        <Button variant="secondary" size="lg" asChild>
          <Link to={localize("/ai-skilling")} className="inline-flex items-center gap-2">
            {t("homeSkilling.cta")}
            <ArrowRight className="w-4 h-4" />
          </Link>
        </Button>
      </Reveal>
    </Section>
  );
};

export default AiSkillingTeaser;
